module.exports = __webpack_public_path__ + "static/img/14010007.a48f47d6.png";